
import Vue from 'vue';
import Component from 'vue-class-component';
import LoadingMixin from './loadingMixin';

@Component({
  name: 'LoadingLayoutSchema',
})
export default class LoadingLayoutSchema extends LoadingMixin {}
